export const breakpoints = {
	"2xl": '1440px',
	lg: "1180px",
	md: "880px",
	sm: "768px",
	xs: "550px",
	"2xs": "340px"
}